document.addEventListener('alpine:init', () => {
  Alpine.data('ThemeModule_ModalCart', ({ openOnAddToCart }) => {
    return {
      init() {
        if (openOnAddToCart === true) {
          document.body.addEventListener(
            'shapes:modalcart:afteradditem',
            () => {
              Alpine.store('modals').open('cart');
              setTimeout(function(){
                cartSellingPlanUpdate();
                getCartSlideRecommend();
                var ageCheck1 = document.querySelector(".ageCheck1");
                if(ageCheck1 != null) {
                  ageCheck1.removeEventListener("change", ageCheckFunction);
                  ageCheck1.addEventListener("change", ageCheckFunction);
                  document.querySelector(".ageCheck1").dispatchEvent(new Event('change'));
                }
              });
            }
          );
        }

        Alpine.store('modals').register('cart', 'rightDrawer');
      },
    };
  });
});

function cartRecommendCTA(e){
  e.preventDefault();
  var that = this;
  this.disabled = true;
  let variantId = this.getAttribute("data-variantid");
  let formData = {
   'items': [{
    'id': variantId,
    'quantity': 6
    }],
    'sections': 'cart-items,cart-footer,cart-item-count',
    'sections_url': window.location.pathname,
  };
  fetch(window.Shopify.routes.root + 'cart/add.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(formData)
  })
  .then(response => {
    return response.json();
  }).then(response => {
    that.disabled = false;
    document.body.dispatchEvent(
      new CustomEvent('shapes:modalcart:cartqtychange', {
        bubbles: true,
        detail: { response: response, originalTarget: false },
      })
    );
  })
  .catch((error) => {
    that.disabled = false;
    console.error('Error:', error);
  });
}

function getCartSlideRecommend() {
  var cartRecItems = document.querySelector(".cartSlideRecommendItems");
  var cartRecItemsWrapper = document.querySelector(".cartSlideRecommendWrapper");
  if(cartRecItems != null) {
    let url = cartRecItems.getAttribute("data-url");
    fetch(window.Shopify.routes.root + url)
      .then(response => response.json())
      .then(({ products }) => {
        if (products.length > 0) {
          cartRecItemsWrapper.style.display = "block";
          cartRecItems.innerHTML = "";
          let add = cartRecItems.getAttribute("data-add");
          let moneyFormat = cartRecItems.getAttribute("data-moneyformat");
          for(let i=0; i< products.length; i++){
            let product = products[i];
            let recItem = document.createElement("div");
            recItem.className = "cartSlideRecommendItem";
            let recItemImage = document.createElement("img");
            recItemImage.src = product.featured_image;
            recItemImage.className = "cartSlideRecommendItemImage";
            let recItemDetail = document.createElement("div");
            recItemDetail.className = "cartSlideRecommendItemDetail";
            let recItemDetailTitle = document.createElement("div");
            recItemDetailTitle.className = "cartSlideRecommendItemDetailTitle";
            recItemDetailTitle.innerHTML = product.title;
            let recItemDetailPrice = document.createElement("div");
            recItemDetailPrice.className = "cartSlideRecommendItemDetailPrice";
            recItemDetailPrice.innerHTML = formatMoney(product.price, moneyFormat);
            recItemDetail.appendChild(recItemDetailTitle);
            recItemDetail.appendChild(recItemDetailPrice);
            let recItemLink = document.createElement("button");
            recItemLink.setAttribute("data-variantid",product.variants[0].id);
            recItemLink.className = "cartSlideRecommendItemLink";
            recItemLink.innerHTML = add;
            recItemLink.addEventListener("click", cartRecommendCTA);
            recItem.appendChild(recItemImage);
            recItem.appendChild(recItemDetail);
            recItem.appendChild(recItemLink);
            cartRecItems.appendChild(recItem);
          }
        } else {
          cartRecItemsWrapper.style.display = "none";
        }
      }
    );
  }
}

function ageCheckFunction() {
  var cartDrawerCheckout = document.querySelector(".cartCheckoutBtn[name='checkout']");
  if(cartDrawerCheckout != null) {
    if(this.checked) {
      cartDrawerCheckout.disabled = false;
    } else {
      cartDrawerCheckout.disabled = true;
    }
  }
}

function cartSellingPlanUpdate(){
  let allCartSellingPlanSelects = document.querySelectorAll(".cartSlideItemSubscribeSelect");
  if(allCartSellingPlanSelects.length > 0) {
    for(let i=0; i<allCartSellingPlanSelects.length; i++) {
      let allCartSellingPlanSelect = allCartSellingPlanSelects[i];
      allCartSellingPlanSelect.removeEventListener("change", cartSellingPlanHandle);
      allCartSellingPlanSelect.addEventListener("change", cartSellingPlanHandle);
    }
  }
}

function cartSellingPlanHandle(){
  let thisLine = this.getAttribute("data-line");
  let thisQty = this.getAttribute("data-quantity");
  let planSelected = this.value;
  let data = {
    quantity: thisQty,
    line: thisLine,
    selling_plan: planSelected == "one-time" ? null : Number(planSelected)
  }
  fetch(window.Shopify.routes.root + 'cart/change.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(data)
  })
  .then(response => response.json())
  .then(data => console.log(data));
}

function formatMoney(cents, format) {
  if (typeof cents == 'string') { cents = cents.replace('.',''); }
  var value = '';
  var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  var formatString = (format || this.money_format);

  function defaultOption(opt, def) {
     return (typeof opt == 'undefined' ? def : opt);
  }

  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultOption(precision, 2);
    thousands = defaultOption(thousands, ',');
    decimal   = defaultOption(decimal, '.');

    if (isNaN(number) || number == null) { return 0; }

    number = (number/100.0).toFixed(precision);

    var parts   = number.split('.'),
        dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
        cents   = parts[1] ? (decimal + parts[1]) : '';

    return dollars + cents;
  }

  switch(formatString.match(placeholderRegex)[1]) {
    case 'amount':
      value = formatWithDelimiters(cents, 2);
      break;
    case 'amount_no_decimals':
      value = formatWithDelimiters(cents, 0);
      break;
    case 'amount_with_comma_separator':
      value = formatWithDelimiters(cents, 2, '.', ',');
      break;
    case 'amount_no_decimals_with_comma_separator':
      value = formatWithDelimiters(cents, 0, '.', ',');
      break;
  }

  return formatString.replace(placeholderRegex, value);
};
